import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';

export const SEE_MORE_LINK_PROPERTIES = {
  displaySeeMoreLink: false,
  seeMoreLinkText: recommendationsPanelsLocaleKeys.panelSeeMoreButton,
  seeMoreLinkStyle: 'font-size:1.4rem;',
  seeMoreLink: null,
};
